import meta from './brand.meta.cjs'
import logo from '@/assets/images/kira-logo.webp'

export const brand = {
  name: meta.name,
  tagline: meta.tagline,
  title: meta.title,
  description: meta.description,
  website: meta.url,
  email: 'contato@kira.com',
  logo,
}
